import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { SpanButtonComponent } from 'src/app/construct-x/shared/components/form-elems/span-button/span-button.component';
import { DialogCertificateDetailComponent } from '../dialog-certificate-detail/dialog-certificate-detail.component';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-dialog-vc-signature',
  imports: [SpanButtonComponent, MatDialogModule, MatIcon, MatTooltip],
  templateUrl: './dialog-vc-signature.component.html',
  styleUrls: ['./dialog-vc-signature.component.scss', '../../../../../components/dialog-windows/dialog.css']
})
export class DialogVcSignatureComponent implements OnInit {

  @ViewChild('keyFileInput') keyFileInput: { nativeElement: HTMLInputElement } | null = null;
  keyFile: string = "";
  keyFileName: string | null = null;

  constructor(public dialogRef: MatDialogRef<DialogCertificateDetailComponent>,  @Inject(MAT_DIALOG_DATA) public data: DialogVcSignatureData) {}

  ngOnInit(): void {
  }

  onKeyUpload(event: any) {
    let file = event.target.files?.[0];
    if (!file) return;
    this.keyFileName = file.name;
    let reader = new FileReader();
    reader.onload = () => { this.keyFile = reader.result as string; };
    reader.onerror = (error) => { console.error('Error reading key:', error); };
    reader.readAsText(file);
  }

  clearKeyFile() {
    this.keyFile = '';
    this.keyFileName = null;
    if (this.keyFileInput?.nativeElement) this.keyFileInput.nativeElement.value = '';
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    if (!this.keyFile) return;
    this.dialogRef.close(this.keyFile);
  }

}


export interface DialogVcSignatureData {
  did: string;
}